<div class="toast-container">
  @for (toast of notifications.toasts(); track toast.id) {
    <app-toast
      [toast]="toast"
      [closing]="toast.closing"
      (closed)="onDismiss(toast.id)"
      (paused)="notifications.pause(toast.id)"
      (resumed)="notifications.resume(toast.id)"
    />
  }
</div>
